import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user.js";
import services from "./modules/services.js";
import counselors from "./modules/counselors.js";
import vuex_homepage from "./modules/vuex_homepage.js";
import vuex_network_counselors from "./modules/vuex_network_counselors.js";
import vuex_booking_form from "./modules/vuex_booking_form.js";
import vuex_admin from "./modules/vuex_admin.js";
import vuex_appointment from "./modules/vuex_appointment.js";
import vuex_rating_and_review from "./modules/vuex_rating_and_review.js";
import axios from 'axios';

Vue.prototype.$http = axios;
Vue.use(Vuex);
// Vue.use(axios);

export const store = new Vuex.Store({
  modules: {
  	user,
  	services,
  	counselors,
  	vuex_homepage,
  	vuex_network_counselors,
  	vuex_booking_form,
  	vuex_admin,
  	vuex_appointment,
    vuex_rating_and_review,
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js